import { F2SummarySVG } from "./SVGIllustrations";
import { CalculatedBadge } from "@/components/we360/CalculatedBadge";
import { CheckOption } from "@/components/we360/CheckOption";

export default function Step6Summary({
  f2Data,
  walkClass,
  squatClass,
  pushupClass,
  flexCategory,
  parqAlerta,
  parqRiskCount,
  confirmacion,
  setConfirmacion,
  errors,
}) {
  return (
    <div>
      <div className="text-center mb-3">
        <F2SummarySVG complete={confirmacion} />
      </div>

      <p
        className="text-xs text-center mb-4 font-medium"
        style={{ color: "#71644C" }}
      >
        Resumen de tu evaluación física
      </p>

      {/* PAR-Q result */}
      <CalculatedBadge
        label="PAR-Q"
        value={parqAlerta ? `${parqRiskCount} riesgo(s)` : "Apto"}
        category={parqAlerta ? "Con alertas" : "Sin alertas"}
        categoryColor={parqAlerta ? "#C0453A" : "#157346"}
        testId="summary-parq"
      />

      {/* 6MWT result */}
      {f2Data.caminata6min && (
        <CalculatedBadge
          label="Caminata 6 min"
          value={`${f2Data.caminata6min}m`}
          category={walkClass?.label || "—"}
          categoryColor={walkClass?.color || "#B5A998"}
          testId="summary-walk"
        />
      )}

      {/* Squats result */}
      {f2Data.sentadillas && (
        <CalculatedBadge
          label="Sentadillas 30s"
          value={`${f2Data.sentadillas}`}
          unit="reps"
          category={squatClass?.label || "—"}
          categoryColor={squatClass?.color || "#B5A998"}
          testId="summary-squats"
        />
      )}

      {/* Push-ups result */}
      {f2Data.flexiones && (
        <CalculatedBadge
          label="Flexiones"
          value={`${f2Data.flexiones}`}
          unit="reps"
          category={pushupClass?.label || "—"}
          categoryColor={pushupClass?.color || "#B5A998"}
          testId="summary-pushups"
        />
      )}

      {/* Flexibility result */}
      {flexCategory && (
        <CalculatedBadge
          label="Flexibilidad"
          value={flexCategory.category}
          categoryColor={flexCategory.color}
          testId="summary-flexibility"
        />
      )}

      {/* Confirmation */}
      <div className="mt-4">
        <CheckOption
          label="Confirmo que he realizado cada prueba siguiendo las instrucciones, en un lugar seguro y bajo mi propia responsabilidad."
          checked={confirmacion}
          onChange={() => setConfirmacion(!confirmacion)}
          testId="f2-confirmacion-check"
        />
        {errors?.getError("confirmacion") && (
          <p className="text-xs mt-1 font-medium" style={{ color: "#C0453A" }} data-testid="f2-confirmacion-error">
            {errors.getError("confirmacion")}
          </p>
        )}
      </div>

      {confirmacion && (
        <div
          className="rounded-xl p-3 mt-3 text-center"
          style={{ background: "#E2F0E8" }}
          data-testid="f2-ready-message"
        >
          <span className="text-[13px] font-semibold" style={{ color: "#157346" }}>
            ¡Listo! Envía tu evaluación.
          </span>
        </div>
      )}
    </div>
  );
}
